import { Building2, User, Landmark, Users, Handshake } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { GroupType } from '@/services/groupService'

interface GroupTypeBadgeProps {
  type?: GroupType
  className?: string
  size?: 'sm' | 'md'
}

const typeConfig: Record<GroupType, { label: string; icon: typeof Building2; color: string }> = {
  club: {
    label: 'Club',
    icon: Building2,
    color: 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300',
  },
  individual: {
    label: 'Individual',
    icon: User,
    color: 'bg-violet-100 text-violet-700 dark:bg-violet-900/40 dark:text-violet-300',
  },
  organisation: {
    label: 'Organisation',
    icon: Landmark,
    color: 'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300',
  },
  community: {
    label: 'Community',
    icon: Users,
    color: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300',
  },
  collaboration: {
    label: 'Collaboration',
    icon: Handshake,
    color: 'bg-rose-100 text-rose-700 dark:bg-rose-900/40 dark:text-rose-300',
  },
}

export function GroupTypeBadge({ type = 'club', className, size = 'sm' }: GroupTypeBadgeProps) {
  const config = typeConfig[type] || typeConfig.club
  const Icon = config.icon

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full font-medium',
        size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-sm',
        config.color,
        className
      )}
    >
      <Icon className={size === 'sm' ? 'h-3 w-3' : 'h-3.5 w-3.5'} />
      {config.label}
    </span>
  )
}

export { typeConfig as groupTypeConfig }

